import React from 'react'
import {connect} from 'react-redux'
import {Field} from 'redux-form';
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import moment from 'moment'
import ReactTooltip from 'react-tooltip';
import 'moment/locale/pt-br'
import '../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import buscarViagens from '../../actions/viagem/buscarViagens';
import alterarViagemSelecionada from '../../actions/viagem/alterarViagemSelecionada';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarOrigem from '../../actions/origem/selecionarOrigem'
import selecionarDataVolta from '../../actions/destino/selecionarDataVolta'
import selecionarDestino from '../../actions/destino/selecionarDestino'
import selecionarUsuario from '../../actions/usuario/selecionarUsuario'
import limparViagens from '../../actions/viagem/limpaViagens';
import Autorizacao from '../../security/Autorizacao';
import {getOperadorEmpresa, getPerfisVendedores, PERFIL_ADMIN, getAdminEmpresa} from '../../security/securityContext';
import {renderField} from '../../util/arraysUtil';
import selecionarDataIda from '../../actions/origem/selecionarDataIda';
import limparDataVolta from '../../actions/destino/limparDataVolta';
import AbaSelecionarEMarcarPoltrona from './AbaSelecionarEMarcarPoltrona';
import selecionarViagemIda from '../../actions/viagem/selecionarViagemIda';
import selecionarViagemVolta from '../../actions/viagem/selecionarViagemVolta';
import limparMapaVeiculoItinerarioIda from '../../actions/mapa-veiculo/limparMapaVeiculoItinerarioIda';
import limparMapaVeiculoItinerarioVolta from '../../actions/mapa-veiculo/limparMapaVeiculoItinerarioVolta';
import { adicionarFormasPagamento } from '../../actions/viagem/adicionarFormasPagamento';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada';
import {showErrorMsg} from '../../util/messagesUtil';
import SelecaoUsuarioEmpresaAutoComplete from '../layout/SelecaoUsuarioEmpresaAutoComplete';
import { campoBuscaTipoVeiculo } from '../../util/constantsUtil';
import ImageGrid from '../veiculo/ImageGrid';
import Modal from '../veiculo/Modal';

registerLocale('pt', pt);
setDefaultLocale('pt');

export const CabecalhoTabela = () => (
  <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
    <div className="row cabecalho-desktop">
      <div className="col">Saida</div>
      <div className="col">Embarque</div>
      <div className="col">Livres</div>
        <div className="col">Prestador</div>
      <div className="col">Categoria</div>
      <div className="col">Veículo</div>
      <div className="col">Valor</div>
      <div className="col">Rota</div>
      <div className="col">Empresa</div>
    </div>
  </div>
);


export class AbaItinerario extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      value: '',
      paginaSelecionada: 1,
      sugestoes: [],
      buscaNaEmpresaSelecionada: true,
      vendaDirecionada: false,
      buscaTipoVeiculo: campoBuscaTipoVeiculo.TODOS.chave,
      selectedImg: null
    };
    this.selecionarDestino = this.selecionarDestino.bind(this);
    this.selecionarOrigem = this.selecionarOrigem.bind(this);
    this.selecionarUsuario = this.selecionarUsuario.bind(this);
  }

  componentDidMount () {
    this.props.selecionarViagemIda();
    this.props.selecionarViagemVolta();
    this.props.limparMapaVeiculoItinerarioIda();
    this.props.limparMapaVeiculoItinerarioVolta();
    this.props.adicionarFormasPagamento(null);
    this.props.adicionarDadosComprador(null);
    this.props.limparViagens();
    this.props.selecionarUsuario(null);
  }

  selecionarDestino (destino) {
    this.props.selecionarDestino(destino);
  }

  selecionarOrigem (origem) {
    this.props.selecionarOrigem(origem);
  }

  selecionarUsuario(usuario) {
    this.props.selecionarUsuario(usuario);
  }

  exibirIconeTaxaEmbarque (viagem) {
    if (viagem && (viagem.taxaEmbarque || viagem.pedagio || viagem.valorAcrescimoMaximoPassagem)) {
      return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`taxa-embarque-${viagem.idItinerario}`}>
                  <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe263;</i>
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`taxa-embarque-${viagem.idItinerario}`}
                                type="dark" effect="solid">
                    <div className="row">Taxa de embarque: {Number(viagem.taxaEmbarque)
                      .toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })}<br/> Total de pedágio: {Number(viagem.pedagio).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                    })}<br/> {viagem.acrescimoMaximoPassagem && Number(viagem.acrescimoMaximoPassagem) > 0 && viagem.valorAcrescimoMaximoPassagem && <>
                       Valor Máximo Passagem: {Number(viagem.valorAcrescimoMaximoPassagem).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL'
                      })}<br/>Percentual Máximo: {Number(viagem.acrescimoMaximoPassagem).toLocaleString('pt-br')}%
                    </>}</div>
                  </ReactTooltip>
                </div>
              </span>
    }
  }

  exibirIconeEmpresa (nomeEmpresa) {
    if (nomeEmpresa) {
      return <span className="align-self-center tooltip-info">
                <a data-tip data-for={`nome-empresa-${nomeEmpresa}`}>
                  {nomeEmpresa}
                </a>
                <div className="tooltip-ut">
                  <ReactTooltip className="tooltip-ut" id={`nome-empresa-${nomeEmpresa}`}
                                type="dark" effect="solid">
                    <div className="row">{nomeEmpresa}</div>
                  </ReactTooltip>
                </div>
              </span>
    }
  }

  selecionarPoltronas () {
    let ida = [];
    let volta = [];
    if (this.props.viagens.passagensRetorno.length > 0) {
      volta = this.props.viagens.passagensRetorno.filter(f => f.selecionada)
    }
    if (this.props.viagens.passagensIda.length > 0) {
      ida = this.props.viagens.passagensIda.filter(f => f.selecionada)
    }
    const viagem = {
      ida: ida[0],
      volta: volta.length > 0 ? volta[0] : null
    };

    this.props.selecionarViagem(viagem);
    this.setState({ paginaSelecionada: 2 })
  }

  alterarEmpresa (viagem) {
    if (this.props.empresaSelecionada.id !== viagem.idEmpresa) {
      const empresa = this.props.empresas.filter(empresa => empresa.id === viagem.idEmpresa)[0];
      this.props.alterarEmpresaSelecionada(empresa);
    }
  }

  selecionarViagem (viagem) {
    if (viagem.sentido === 'IDA') {
      if (this.props.viagemVolta && this.props.viagemVolta.idEmpresa !== viagem.idEmpresa) {
        showErrorMsg('Selecione passagens na mesma empresa.');
        return
      }
      this.alterarEmpresa(viagem);
      this.props.selecionarViagemIda(viagem);
    }
    if (viagem.sentido === 'VOLTA') {
      if (this.props.viagemIda && this.props.viagemIda.idEmpresa !== viagem.idEmpresa) {
          showErrorMsg('Selecione passagens na mesma empresa.');
        return
      }
      this.alterarEmpresa(viagem);
      this.props.selecionarViagemVolta(viagem);
    }
    this.props.alterarViagemSelecionada(viagem);
  }

  exibirIconeLimparRetorno () {
    if (this.props.dataVolta) {
      return (
        <div>
          <i className="material-icons mt-2" style={{
            marginLeft: '-45px',
            position: 'absolute',
            cursor: 'pointer'
          }} onClick={() => {
            this.props.limparDataVolta();
            this.props.selecionarViagemVolta(null)
          }}>&#xe5cd;</i>
        </div>)
    }
    return '';
  }

  limpaViagens (sentido) {
    if (sentido === 'pesquisaOrigem') {
      this.selecionarOrigem(null)
    }
    if (sentido === 'pesquisaDestino') {
      this.selecionarDestino(null)
    }
    this.props.selecionarViagemVolta(null);
    this.props.selecionarViagemIda(null);
    this.props.limparViagens()
  }

  buscarViagens () {
    this.props.selecionarViagemVolta(null);
    this.props.selecionarViagemIda(null);
    if (this.props.origem || this.props.destino) {
      this.props.buscarViagens(
        this.props.origem.id,
        this.props.destino.id,
        this.props.dataIda,
        this.props.dataVolta,
        this.props.empresaSelecionada.id,
        false,
        this.state.buscaNaEmpresaSelecionada,
        this.state.buscaTipoVeiculo
      )
    }
  }

  setSelectedImg(selectedImg) {
    this.setState({ selectedImg })
  }

  exibirBotaoPesquisarDestinos () {
    return (
      <div className="col-12 col-sm-9 col-md-2">
        <button onClick={() => this.buscarViagens()} style={{ fontSize: 18 }}
                disabled={!this.props.origem || !this.props.destino || !this.props.dataIda}
                className='btn botaoLogar btn-laranja'>Buscar
        </button>
      </div>)
  }

  exibirItinerario (passagens, label) {
    if (passagens && passagens.length) {
      if (passagens.length === 1 && passagens[0].selecionada === undefined) {
        this.selecionarViagem(passagens[0])
      }
      return (
        <React.Fragment><span className='row  mt-3 ml-2'>{label}</span>
          <div className="lista-table">
            <div className="geral">
              {passagens.sort((a, b) => new Date(a.dataHoraPartida) - new Date(b.dataHoraPartida))
                .map(viagem => <a target="_BLANK" key={viagem.idItinerario} style={{ cursor: 'pointer' }}
                                          onClick={() => this.selecionarViagem(viagem)}>
                <div className={`${viagem.selecionada ? 'resumo-laranja' : 'resumo'}`} key={viagem.idItinerario}>
                  <div className='row'>
                    <div className="col">
                      <span className="titulo-mobile">Saída:&nbsp;</span>
                      {viagem.dataPartida} às {viagem.horaPartida}
                    </div>
                    <div className="col">
                      <span className="titulo-mobile">Embarque:&nbsp;</span>
                      {viagem.embarque}
                    </div>
                    <div className="col">
                      <span className="titulo-mobile">Assentos livres:&nbsp;</span>{viagem.assentosDisponiveis}
                    </div>
                      <div className="col">
                          <span className="titulo-mobile">Prestador:&nbsp;</span>{viagem.nomePrestador? viagem.nomePrestador : '-'}
                      </div>

                    <div className="col">
                      <span className="titulo-mobile">Categoria:&nbsp;</span>{viagem.descricaoTipoVeiculo}
                      <><ImageGrid setSelectedImg={this.setSelectedImg.bind(this)} veiculo={viagem.imagemVeiculo} tipoVeiculo={viagem.tipoImagemVeiculo} />
                          {this.state.selectedImg && <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />}</>
                    </div>
                    <div className="col">
                      <span className="titulo-mobile">Veículo:&nbsp;</span>{viagem.veiculo}
                    </div>
                    <div className="col">
                      <span className="titulo-mobile">Valor R$:&nbsp;</span>
                      {Number(viagem.preco)
                        .toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL'
                        })}
                      {this.exibirIconeTaxaEmbarque(viagem)}
                    </div>
                    <div className="col">
                      {viagem.descRota}
                    </div>
                    <div className="col">
                      {this.exibirIconeEmpresa(viagem.nomeEmpresa)}
                    </div>
                  </div>
                  <div className="row mt-1" style={{ fontWeight: 'bold' }}>
                    <div className="col-2">
                        <span>Itinerário:&nbsp;</span> {viagem.idItinerario}
                    </div>
                    <div className="col">
                        <span>Rota:&nbsp;</span> {viagem.idRota}
                    </div>
                  </div>
                </div>
              </a>)}
            </div>
          </div>
        </React.Fragment>

      )
    }
    if ((label === 'IDA' && passagens) || (label === 'VOLTA' && this.props.dataVolta && passagens)) {
      return (
        <React.Fragment>
          <span className='row  mt-3 ml-2'>{label}</span>
          <div className="alert alert-warning text-center" role="alert">
            Não foi encontrado resultado para sua pesquisa.
          </div>
        </React.Fragment>
      )
    }
  }

  selecionarData (data, ida) {
    if (ida) {
      this.props.selecionarDataIda(data);
      this.props.limparDataVolta();
    } else {
      this.props.selecionarDataVolta(data);
    }
  }

  exibirCalendario (ida) {
    let data;

    let minDate = new Date();
    if (ida) {
      if (this.props.dataIda) {
        data = moment(this.props.dataIda)
          .toDate()
      }
    } else {      
      if (this.props.dataVolta) {
        data = moment(this.props.dataVolta)
          .toDate()
      }
    }
    return (
      <div>
        <div className="linha">
          <DatePicker
            className='form-control form-control-lg campo-busca'
            placeholderText={ida ? 'Data Ida' : 'Data Volta'}
            value={data}
            minDate={minDate}
            locale="pt-BR"
            selected={data}
            startDate={moment(this.props.dataIda)
              .toDate()}
            endDate={moment(this.props.dataVolta)
              .toDate()}
            disabled={!ida && !this.props.dataIda}
            onChange={(date) => {
              this.selecionarData(date, ida);
              this.limpaViagens('data')
            }}
            dateFormat="dd/MM/yyyy"
            withPortal
          />
        </div>
      </div>
    )
  }

  exibirCampoBusca () {
    return (<React.Fragment>
      <div className="input-group mb-3 mt-3">
        <div className="col-12 col-sm-12 col-md-3 mb-3">
          <SelecaoCidadeAutocomplete limparViagens={this.limpaViagens.bind(this)}
                                     name='pesquisaOrigem'
                                     ehVenda={true}
                                     placeholder='Cidade origem'
                                     selecionarCidade={this.selecionarOrigem}
                                     value={this.props.origem}
          />
        </div>
        <div className="col-12 col-sm-12 col-md-3 mb-3">
          <SelecaoCidadeAutocomplete name='pesquisaDestino'
                                     ehVenda={true}
                                     limparViagens={this.limpaViagens.bind(this)}
                                     placeholder='Cidade destino' selecionarCidade={this.selecionarDestino}
                                     value={this.props.destino}
          />
        </div>

        <div className="col-12 col-sm-12 col-md-2 mb-3">
          {this.exibirCalendario(true)}
        </div>

        <div className="col-12 col-sm-12 col-md-2 mb-3">
          {this.exibirCalendario()}
        </div>
        {this.exibirIconeLimparRetorno()}
        {this.exibirBotaoPesquisarDestinos()}

        <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12"/>
        <Field name="destino" type="hidden" component={renderField} css="form-control col-md-12"/>
      </div>
    </React.Fragment>)
  }

  marcarDesmarcarCheckboxVendaDirecionada(e) {
      if (!e.target.checked) {
        this.setState({ vendaDirecionada: false });
        this.selecionarUsuario(null)
      } else {
        this.setState({ vendaDirecionada: true })
      }
  }

  exibirOpcoesTipoVeiculo() {
    return (<div className="col-12 col-sm-12 col-md-6">
      <input type="radio" 
            name="tipoVeiculoVeiculo"            
            checked={this.state.buscaTipoVeiculo == campoBuscaTipoVeiculo.TODOS.chave}
            onChange={() => this.setState({ buscaTipoVeiculo: campoBuscaTipoVeiculo.TODOS.chave })}
            /> Todos <br/>
      <input type="radio" 
            name="tipoVeiculoVeiculo"            
            checked={this.state.buscaTipoVeiculo == campoBuscaTipoVeiculo.RODOVIARIO.chave}
            onChange={() => this.setState({ buscaTipoVeiculo: campoBuscaTipoVeiculo.RODOVIARIO.chave })} 
            /> Rodoviário(ônibus, van, mocro-ônibus, carro) <br/>
      <input type="radio" 
            name="tipoVeiculoVeiculo"            
            checked={this.state.buscaTipoVeiculo == campoBuscaTipoVeiculo.AQUAVIARIO.chave}           
            onChange={() => this.setState({ buscaTipoVeiculo: 'AQUAVIARIO' })} 
            /> Aquaviário (Embarcação) <br/>
    </div>)
  }

  exibirOpcoesBuscaEmpresa(){
    if(this.props.reservasSelecionadas === null){
      return(
        <div className="input-group mb-2">
          <div className="col-12 col-sm-12 col-md-6">
            <input type="radio" name='radioBusca' id='radioEmpresaSelecionada'
                   onChange={() => this.setState({buscaNaEmpresaSelecionada: true})}
                   checked={this.state.buscaNaEmpresaSelecionada}
            /> - {this.props.empresaSelecionada.nome}
          </div>
          <div className="col-12 col-sm-12 col-md-6">
            <input type="radio"
                   onChange={() => this.setState({buscaNaEmpresaSelecionada: false})}
                   name='radioBusca' id='radioTodasEmpresas'/> - Buscar em todas as empresas que tenho perfil de vendedor.
          </div>
          <div className="col-12 col-sm-12 col-md-6"/>
          <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id), PERFIL_ADMIN]}>
            <div className="col-12 col-sm-12 col-md-6 mt-4">
              <input type="checkbox"
                      onChange={(e) => this.marcarDesmarcarCheckboxVendaDirecionada(e)}
                      name='radioBusca' id='radioVendaDirecionada'/> - Direcionar venda
            </div>
          </Autorizacao>
        </div>
      )
    }
    return ''
  }

  exibirOpcaoBuscaVendedor(){
    return (
    <React.Fragment>
      <Autorizacao perfisPermitidos={[getAdminEmpresa(this.props.empresaSelecionada.id), PERFIL_ADMIN]}>
        {this.state.vendaDirecionada === true ?
            <div className="input-group mb-3 mt-3 justify-content-end">
              <div className="col-md-6 col-sm-12">
                <SelecaoUsuarioEmpresaAutoComplete
                                          name='pesquisaUsuario'
                                          placeholder='Nome, e-mail ou código do vendedor'
                                          selecionarUsuario={this.selecionarUsuario}
                                          value={this.props.usuarioSelecionado}
                />
              </div>
            </div> : ''}
      </Autorizacao>
            </React.Fragment>)
  }

  exibirAtual () {
    if (this.state.paginaSelecionada === 1) {
      return (<div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
        {this.exibirCampoBusca()}
        {this.exibirOpcoesBuscaEmpresa()}
        {this.exibirOpcaoBuscaVendedor()}
        {this.exibirOpcoesTipoVeiculo()}
        {this.props.viagens.passagensIda || this.props.viagens.passagensRetorno ? <CabecalhoTabela/> : ''}
        {this.exibirItinerario(this.props.viagens.passagensIda, 'IDA')}
        {this.exibirItinerario(this.props.viagens.passagensRetorno, 'VOLTA')}
      </div>)
    }

    if (this.state.paginaSelecionada === 2) {
      return <AbaSelecionarEMarcarPoltrona voltar={() => this.setState({ paginaSelecionada: 1 })}/>
    }
    return '';
  }

  exibir () {
    if (this.props.caixaAberto) {
      return this.exibirAtual()
    }
    return <div className='col-12'>
      <div className="mt-2 alert alert-warning text-center" role="alert">
        Seu caixa está em análise de fechamento. Para efetuar mais vendas contate seu gerente.
      </div>
    </div>;
  }

  render () {
    return (
      <Autorizacao
        perfisPermitidos={[getOperadorEmpresa(this.props.empresaSelecionada.id), ...getPerfisVendedores(this.props.empresaSelecionada.id), PERFIL_ADMIN]}>
        <div className="row internas">
          {this.exibir()}
        </div>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (

  {
    viagens: state.viagens,
    viagemIda: state.viagemIda,
    viagemVolta: state.viagemVolta,
    viagem: state.viagem,
    origem: state.origem,
    destino: state.destino,
    dataIda: state.dataIda,
    dataVolta: state.dataVolta,
    empresaSelecionada: state.empresaSelecionada,
    cidades: state.cidades,
    caixaAberto: state.caixaAberto,
    reservasSelecionadas: state.remarcacao.reservasSelecionadas,
    empresas: state.authentication.empresas,
    usuarioSelecionado: state.usuarioSelecionado
  });

export default connect(mapStateToProps,
  {
    selecionarDestino,
    selecionarOrigem,
    buscarViagens,
    limparViagens,
    selecionarViagemIda,
    selecionarViagemVolta,
    selecionarDataVolta,
    selecionarDataIda,
    limparDataVolta,
    alterarViagemSelecionada,
    limparMapaVeiculoItinerarioIda,
    limparMapaVeiculoItinerarioVolta,
    adicionarFormasPagamento,
    adicionarDadosComprador,
    alterarEmpresaSelecionada,
    selecionarUsuario
  })(AbaItinerario)
